import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'

export const isVoc = (viewOption: InsightViewOptionStrings) =>
  viewOption === InsightViewOption.STAR_RATINGS || viewOption === InsightViewOption.SURVEY_SCORES

export const shouldShowAverageInformation = (viewOption?: InsightViewOptionStrings) => {
  if (!viewOption) {
    return false
  }

  switch (viewOption) {
    case InsightViewOption.NET_SENTIMENT:
    case InsightViewOption.PASSION_INTENSITY:
    case InsightViewOption.ENGAGEMENT_RATIO_ONLY:
    case InsightViewOption.STAR_RATINGS:
    case InsightViewOption.SURVEY_SCORES:
      return true

    default:
      return false
  }
}
